import createDraggingGhost from "utils/createDraggingGhost";

import classes from "../DraggableButton.module.scss";

export { default as findRowIndexById } from "./findRowIndexById";
export { default as getPathToTableRow } from "./getPathToTableRow";
export { default as moveItemBySourceId } from "./moveItemBySourceId";
export { default as removeItemByPath } from "./removeItemByPath";

export const createTableRowGhost = (e) => {
  const rowEl = e.target.closest(".row");
  const { width: rowWidth, height: rowHeight } = rowEl.getBoundingClientRect();

  rowEl.classList.add("dragged");

  const wrapper = document.createElement("div");
  wrapper.classList.add("generic_table__body");
  wrapper.style.width = `${rowWidth}px`;
  wrapper.style.height = `${rowHeight}px`;

  const ghost = createDraggingGhost(rowEl, {
    className: classes["draggable_cell__ghost"],
    wrapper,
  });

  const bodyRow = ghost.querySelector(".body-row");
  if (bodyRow) {
    bodyRow.style.position = "static";
    bodyRow.style.transform = "unset";
  }

  return ghost;
};
